import React from 'react';
import ReactChipInput from "react-chip-input";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import { CONTACT_NO_NEED_APPROVE_FIELDS } from "@app/constants/Common";

const ContactsOtherCard = ({
    isEditOtherContacts,
    setIsEditOtherContacts,
    updateCandidateContacts,
    contacts,
    onAddContactItem,
    onRemoveContactItem,
    inputDisableView,
    allInputInfo,
    mode = 'Edit', // Default to Edit mode for backward compatibility
    isEditOtherContactsProp = false
}) => {
    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Other Contacts</h3>
                {mode === 'Edit' && (
                    <div className='card-tools'>
                        {(isEditOtherContacts || isEditOtherContactsProp) &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => {
                                        setIsEditOtherContacts(false);
                                    }}
                            >
                                Cancel
                            </button>
                        }
                        {(isEditOtherContacts || isEditOtherContactsProp) &&
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={() => {
                                        updateCandidateContacts();
                                    }}
                            >
                                Save
                            </button>
                        }
                        {!(isEditOtherContacts || isEditOtherContactsProp) &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEditOtherContacts(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                    </div>
                )}
            </div>
            <div className='card-body pt-0'>
                {CONTACT_NO_NEED_APPROVE_FIELDS.map((field, i) => {
                    let fieldValue = contacts[field.key] ? contacts[field.key] : []
                    return <div className='input-group mt-3' key={`contact_other_${field.key}`}>
                        <label className={'w-100'}>{field.label}</label>
                        <ReactChipInput
                            classes="class1 class2 w-100"
                            chips={fieldValue}
                            onSubmit={value => onAddContactItem(value, field.key)}
                            onRemove={index => onRemoveContactItem(index, field.key)}
                        />
                        {!(isEditOtherContacts || isEditOtherContactsProp) && inputDisableView(fieldValue, i)}
                        <AllUserInputField arrInfo={allInputInfo.allContactsInfo}
                                           field={field.key}/>
                    </div>
                })}
            </div>
        </div>
    );
};

export default ContactsOtherCard;


